import {CarouselButton} from "../types/carousel.types";

export const actionCarouselButtons: Array<CarouselButton> = [
  {
    action: 'prev',
    className: 'carousel-arrow-prev',
    icon: 'arrow_back'
  },
  {
    action: 'next',
    className: 'carousel-arrow-next',
    icon: 'arrow_forward'
  }
]

export const minSwipeDistance: number = 50;

export const carouselBreakpoints = {
  mobile: {
    query: '(max-width: 768px)',
    visibleItems: 1
  },
  tablet: {
    query: '(max-width: 1200px)',
    visibleItems: 2
  }
} as const;

